import { styled } from '@material-ui/core';
import { Alert, OutlinedButton, FormLabel } from '@ds/react-components';

import {
  Paper,
  PaperBody,
  PaperHeader,
  PaperHeaderText,
} from '../../Cancellation.styled';

export const InfoAlert = styled(Alert)({
  marginTop: '18px',
  maxWidth: '910px',
});

export const InfoAlertMessage = styled(Alert.AlertMessage)({
  fontWeight: 'bold',
});

export { Paper, PaperHeader, PaperHeaderText };

export const PaperBodyOverload = styled(PaperBody)({
  padding: '2px 32px 16px 32px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
});

export const BodySectionWrapper = styled('div')({
  margin: '16px 0px',
});

export const InfoLabel = styled(FormLabel)(({ theme }) => ({
  color: theme.palette.common.lightText,
}));

export const InfoText = styled('div')(({ theme }) => ({
  fontSize: '14px',
  color: theme.palette.common.black,
}));

export const InfoSubTextContainer = styled('div')(({ theme }) => ({
  fontSize: '12px',
  marginTop: '4px',
  color: '#BEBEBE',
}));

export const InfoSubText = styled('p')({
  padding: 0,
  margin: 0,
});

export const BackButton = styled(OutlinedButton)({
  marginTop: '18px',
});
